// extracted by mini-css-extract-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-Capture-absolute-center","documentContainer":"onfido-sdk-ui-Capture-documentContainer","faceContainer":"onfido-sdk-ui-Capture-faceContainer"};